'use strict';

var helper = require('../helper');

module.exports = {
    pushHeaderClickInteractionFor (item) {
        if (!item || item == 'unknown') {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '4',
            'eventname': 'header',
            'menu_items': item
        };

        helper.log('Pushing header click impression for ' + item + '!', true);
        helper.push(pushObject);
    },

    pushSearchInteraction (searchTerm) {
        if (!searchTerm || searchTerm.length === 0) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '14',
            'eventname': 'search',
            'type': 'type_in',
            'search_term': searchTerm
        };

        helper.log('Pushing search interaction for ' + searchTerm + '!', true);
        helper.push(pushObject);
    },

    pushPrivacyPolicyPopUP (pageType, privacyNews, privacyCustomNews) {
        if (!pageType) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '138',
            'eventname': 'privacy_contents',
            'action': pageType,
            'position': 'pop_up',
            'privacy_news': privacyNews,
            'privacy_custom_news': privacyCustomNews
        };

        helper.log('Pushing pushPrivacyPolicyPopUP!', true);
        helper.push(pushObject);
    },

    // 6.15 SEARCH - LIVE SUGGESTION RESULTS
    pushSearchLiveSuggestionResults (section, item) {
        if (!section && !item) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '72',
            'eventname': 'search',
            'type': 'tips_clicked',
            'label': section,
            'search_term': item
        };

        helper.log('Pushing footer link click for ' + section + ', ' + item + '!', true);
        helper.push(pushObject);
    },

    // 6.16 SEARCH - CLICK TO CLOSE THE SEARCH BAR
    pushSearchOnCloseBtn (action) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '73',
            'eventname': 'search',
            'type': action
        };
        helper.log('Pushing close btn on search', true);
        helper.push(pushObject);
    },

    // Menu
    pushMenuItemClickInteractionFor (item, category) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '5',
            'eventname': 'menu',
            'menu_items': item,
            'category': category
        };

        helper.log('Pushing menu click impression for ' + item + '!', true);
        helper.push(pushObject);
    },

    pushMenuContentClickInteraction (item) {
        if (!item) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '7',
            'eventCategory': 'fuori_menu',
            'eventAction': 'clic',
            'eventLabel': item
        };

        helper.log('Pushing menu content link click impression for ' + item + '!', true);
        helper.push(pushObject);
    },

    pushOutOfMenuClickInteraction (voice) {
        if (!voice) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '74',
            'eventname': 'out_menu',
            'menu_items': voice
        };

        helper.log('Pushing out of menu click impression for ' + voice + '!', true);
        helper.push(pushObject);
    },

    // Search Filters
    pushSearchFilterSelectInteraction (category, selection, action) {
        if (!category && !action) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '15',
            'eventname': 'listing_filter',
            'action': action,
            'type': category,
            'text': selection,
        };

        helper.log('Pushing search filter impression for \'' + action + '\', \'' + category + '\', \'' + selection + '\'!', true);
        helper.push(pushObject);
    },

    pushSearchSortInteraction (orderType) {
        if (!orderType) {
            return;
        }

        orderType = helper.formatString(orderType);

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '16',
            'eventname': 'listing_sort_by',
            'type': orderType
        };

        helper.log('Pushing sort listing impression for ' + orderType + '!', true);
        helper.push(pushObject);
    },

    // Contact Us
    pushContactUsInteraction (requestType) {
        if (!requestType) {
            return;
        } else {
            let request = requestType.split(' ').join('_').toLowerCase();
            requestType = request.split('-').join('');
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '23',
            'eventname': 'contact_us',
            'text': requestType
        };

        helper.log('Pushing contact us impression for ' + requestType + '!', true);
        helper.push(pushObject);
    },

    // Social icons footer
    pushSocialClickInteractionFooter (social) {
        if (!social) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '28',
            'eventname': 'social',
            'action': 'follow',
            'type': social
        };

        helper.log('Pushing social footer click impression for ' + social + '!', true);
        helper.push(pushObject);
    },

    pushFooterLinkClickInteraction (type, name, category) {
        if (!name || !type || !category) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '6',
            'eventname': 'footer',
            'menu_items': name,
            'type': type,
            'category': category
        };

        helper.log('Pushing footer link click for ' + type + ', ' + name + '!', true);
        helper.push(pushObject);
    },

    giftcardCheckBalance (data) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '51',
            'eventname': 'gift_card',
            'action': 'check',
            'text': data.gcType,
            'coupon': data.gcCode
        };

        helper.log('Pushing giftcard check balance ' + data.gcType + '!', true);
        helper.push(pushObject);
    },

    pushNotifyMeSoldOutSize (availability, productName, size, sku) {
        if (!availability || !productName || !size || !sku) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '52',
            'eventname': 'product',
            'type': availability,
            'action': 'notify_me',
            'text': size,
            'product_id': sku + '_' + size
        };

        helper.log('Pushing notify me sold out size ' + size + ', ' + productName + ', ' + sku + '!', true);
        helper.push(pushObject);
    },

    pushActionsOnTheNotifyMePopup (cta, productName, size, sku) {
        if (!size || !cta || !sku || !productName) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '53',
            'eventname': 'product',
            'action': cta,
            'text': size,
            'product_id': sku + '_' + size
        };

        helper.log('Pushing actions on the notify me popup ' + size + ', ' + cta + ', ' + sku + '!', true);
        helper.push(pushObject);
    },

    pushCheckAvailabilitySoldOutSize (productName, size, sku, isNotAvailable) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': isNotAvailable ? '65' : '97',
            'eventname': isNotAvailable ? 'product_notify_me' : 'product',
            'action': 'check_availability',
            'text': size,
            'type': isNotAvailable ? 'no_online_availability' : 'online_availability',
            'product_id': sku + '_' + size
        };

        helper.log('Pushing product_notify_me sold out size ' + productName + ', ' + size + ', ' + sku + '!', true);
        helper.push(pushObject);
    },

    pushCheckAvailabilityChangeSize (productName, size, sku) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '97',
            'eventname': 'product',
            'action': 'check_availability',
            'text': size,
            'type': 'online_availability',
            'product_id': sku
        };

        helper.log('Pushing product_notify_me sold out size ' + productName + ', ' + size + ', ' + sku + '!', true);
        helper.push(pushObject);
    },

    pushNotfyMeCtaClickSoldout (sku) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '98',
            'eventname': 'product',
            'action': 'notify_me',
            'product_id': sku
        };

        helper.log('Pushing notify me PDP CTA click for soldout product', true);
        helper.push(pushObject);
    },

    pushPerfectBraModelInteraction (location) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '49',
            'eventname': 'find_your_bra',
            'position': location
        };

        helper.log('Pushing perfect bra interaction!', true);
        helper.push(pushObject);
    },

    pushUnsubscribePhone () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '66',
            'eventname': 'sms_unsubscribe'
        };

        helper.log('Pushing sms unsubscribe!', true);
        helper.push(pushObject);
    },

    pushActionOnTheBottoms (action) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '67',
            'eventname': 'general_cta',
            'action': action
        };

        helper.log('Pushing user content interaction!', true);
        helper.push(pushObject);
    },

    pushCancelYourOrderInteraction (orderId) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '69',
            'eventname': 'cancel_your_order',
            'action': 'click',
            'order': orderId
        };

        helper.log('Pushing cancel your order interaction!', true);
        helper.push(pushObject);
    },

    pushCancelYourOrderInteractionAction (orderId, action) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '70',
            'eventname': 'cancel_your_order',
            'action': action,
            'order': orderId
        };

        helper.log('Pushing cancel your order interaction!', true);
        helper.push(pushObject);
    },

    // Splash Page
    pushSplashPageChanges (gender) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '71',
            'eventname': 'splashpage',
            'type': gender
        };

        helper.log('Pushing splash page changes interaction for \'' + gender + '\'!', true);
        helper.push(pushObject);
    },

    // Made In
    pushReadTheWholeInterview () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '83',
            'eventname': 'made_in',
            'action': 'read_the_whole_interview'
        };

        helper.log('Pushing read the whole interview interaction!', true);
        helper.push(pushObject);
    },

    pushMadeInPlantInteraction (plant) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '84',
            'eventname': 'made_in',
            'action': 'click',
            'text': plant
        };

        helper.log('Pushing read the made in plant interaction for ' + plant + ' !', true);
        helper.push(pushObject);
    },

    pushMadeInTheProjectsInteraction (project) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '85',
            'eventname': 'made_in',
            'action': 'find_out_more',
            'text': project
        };

        helper.log('Pushing read the made in plant interaction for ' + project + ' !', true);
        helper.push(pushObject);
    },

    pushFindInStoreForAvailableProductInteraction (sku, name, size) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '96',
            'eventname': 'product',
            'action': 'search_in_store',
            'product_id': size ? sku + '_' + size : sku
        };

        helper.log('Pushing find in store click for available product!', true);
        helper.push(pushObject);
    },

    pushFindInStoreForNotAvailableProductInteraction (sku, name, size) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '53',
            'eventname': 'product',
            'action': 'search_in_store',
            'product_id': size ? sku + '_' + size : sku
        };
        if (size) {
            pushObject.text = size;
        }

        helper.log('Pushing find in store click for not available product!', true);
        helper.push(pushObject);
    },

    pushSmartGift (sku, name) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '100',
            'eventname': 'send_product_with_smartgift',
            'product_id': sku.replace(/\s+/g, '_')
        };

        helper.log('Pushing smartgift event!', true);
        helper.push(pushObject);
    },

    pushVideoPlayEvent (action, name, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '43',
            'eventname': 'video_start',
            'type': action,
            'video_title': name,
            'product_id': sku
        };

        helper.log('Pushing play video event!', true);
        helper.push(pushObject);
    },

    pushVideoPauseEvent (name, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '44',
            'eventname': 'video_pause',
            'video_title': name,
            'product_id': sku
        };

        helper.log('Pushing pause video event!', true);
        helper.push(pushObject);
    },

    pushVideo25Event (name, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '46',
            'eventname': 'video_progress',
            'video_percent': '25',
            'video_title': name,
            'product_id': sku
        };

        helper.log('Pushing pause 25 video event!', true);
        helper.push(pushObject);
    },

    pushVideo50Event (name, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '47',
            'eventname': 'video_progress',
            'video_percent': '50',
            'video_title': name,
            'product_id': sku
        };

        helper.log('Pushing pause 50 video event!', true);
        helper.push(pushObject);
    },

    pushVideo75Event (name, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '48',
            'eventname': 'video_progress',
            'video_percent': '75',
            'video_title': name,
            'product_id': sku
        };

        helper.log('Pushing pause 75 video event!', true);
        helper.push(pushObject);
    },

    pushFullVideoEvent (name, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '45',
            'eventname': 'video_complete',
            'video_title': name,
            'product_id': sku
        };

        helper.log('Pushing full video event!', true);
        helper.push(pushObject);
    },

    pushSmartGiftBasketInteraction106 (action, skus, quantity) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '106',
            'eventname': 'product_smartgift',
            'action': action,
            'type': quantity,
            'product_id': skus
        };

        helper.log('Pushing smartgift basket button interaction event! ', true);
        helper.push(pushObject);
    },

    pushSmartGiftBasketInteraction107 (productName, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '107',
            'eventname': 'product_smartgift',
            'action': 'remove',
            'product_id': sku
        };

        helper.log('Pushing smartgift basket remove product interaction event!', true);
        helper.push(pushObject);
    },

    pushSmartGiftBasketInteraction108 (location) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '108',
            'eventname': 'product_smartgift',
            'action': 'open_banner',
            'position': location
        };

        helper.log('Pushing smartgift basket mini icon interaction event!', true);
        helper.push(pushObject);
    },

    pushSmartGiftMoreInfo () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '109',
            'eventname': 'product_smartgift',
            'action': 'more_info'
        };

        helper.log('Pushing pushSmartGiftMoreInfo more info interaction event!', true);
        helper.push(pushObject);
    },
    pushSelectSize (sku) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '118',
            'eventname': 'product',
            'action': 'select_size',
            'product_id': sku
        };

        helper.log('Pushing pushSelectSize more info interaction event!', true);
        helper.push(pushObject);
    },

    pushPromoAncor (text) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '120',
            'eventname': 'promotional_message',
            'text': text
        };

        helper.log('Pushing pushPromoAncor more info interaction event!', true);
        helper.push(pushObject);
    },

    pushShopTheLook (sku) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '119',
            'eventname': 'shop_the_look',
            'product_id': sku
        };

        helper.log('Pushing shop the look interaction event!', true);
        helper.push(pushObject);
    },

    pushCustomizeProduct (productName, sku) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '123',
            'eventname': 'product',
            'action': 'customize',
            'category': productName,
            'product_id': sku

        };

        helper.log('Pushing pushCustomizeProduct info interaction event!', true);
        helper.push(pushObject);
    },

    pushCustomizeProductAction (action, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '134',
            'eventname': 'product',
            'action': 'customize_action',
            'type': action,
            'product_id': sku
        };

        helper.log('Pushing pushCustomizeProduct info interaction event!', true);
        helper.push(pushObject);
    },

    pushLoyaltyCta (action, text) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '122',
            'eventname': 'loyalty_message',
            'action': text,
            'position': action
        };

        helper.log('Pushing pushLoyaltyCta info interaction event!', true);
        helper.push(pushObject);
    },

    pushBubbleClickInteraction (pageType) {
        if (!pageType) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '110',
            'eventname': 'popup_help',
            'action': 'clic'
        };

        helper.log('Pushing bubble chat click interaction!', true);
        helper.push(pushObject);
    },

    pushESWInteraction (selection, pageType) {
        if (!selection || !pageType) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '111',
            'eventname': 'popup_help',
            'action': selection
        };

        helper.log('Pushing esw interaction!', true);
        helper.push(pushObject);
    },

    pushEcoChoiceClick (location, user) {
        if (!location) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'eventID': '77',
            'eventname': 'ecological_choice_more_info',
            'position': location,
            'type': user || 'not_available'
        };

        helper.log('Pushing eco choice click interaction: ', true);
        helper.push(pushObject);
    },

    pushTrackYourOrder (transactionID) {
        if (!transactionID) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '112',
            'eventname': 'track_your_order',
            'order': transactionID
        };

        helper.log('Pushing track your order interaction!', true);
        helper.push(pushObject);
    },

    pushPersonalAreaNavigationOrderSection (cta, orderType) {
        if (!cta || !orderType) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '114',
            'eventname': 'my_orders_select',
            'text': cta + '-' + orderType
        };

        helper.log('Pushing personal area navigation order section interaction!', true);
        helper.push(pushObject);
    },

    pushMainMenuClickInteraction (cta) {
        if (!cta) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '143',
            'eventname': 'main_menu',
            'menu_items': cta
        };

        helper.log('Pushing main menu click interaction!', true);
        helper.push(pushObject);
    },
    // 7.139 COOKIE BANNER
    pushCookieBanner (ctaClicked) {
        if (!ctaClicked) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '147',
            'eventname': 'cookie_banner',
            'label': ctaClicked
        };

        helper.log('Pushing cookie banner cta ' + ctaClicked, true);
        helper.push(pushObject);
    },

    // 7.152 PRE-FOOTER
    pushPreFooterCtaClick (cta) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '160',
            'eventname': 'pre_footer',
            'action': cta
        };

        helper.log('Pushing pre footer cta click interaction!', true);
        helper.push(pushObject);
    },

    pushMenuIconOnVW (item) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '1',
            'eventname': 'menu',
            'menu_items': item
        };

        helper.log('Pushing header click impression for ' + item + '!', true);
        helper.push(pushObject);
    },

    pushMenuGenderVW (gender) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '2',
            'eventname': 'menupage',
            'type': gender
        };

        helper.log('Pushing splash page changes interaction for \'' + gender + '\'!', true);
        helper.push(pushObject);
    },

    pushMenuCategoryVW (item, category) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '3',
            'eventname': 'menupage',
            'menu_items': item,
            'category': category
        };

        helper.log('Pushing menu click impression for ' + item + '!', true);
        helper.push(pushObject);
    },

    pushSearchInteractionForVW (searchTerm) {
        if (!searchTerm || searchTerm.length === 0) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '4',
            'eventname': 'search',
            'type': 'type_in',
            'search_term': searchTerm
        };

        helper.log('Pushing search interaction for ' + searchTerm + '!', true);
        helper.push(pushObject);
    },
};
